import './Popover.scss'
import React, { PureComponent } from 'react'
import classNames from 'classnames'
import { Popover as AntPopover } from 'antd'

export default class Popover extends PureComponent {
  render() {
    const { className } = this.props
    const PopoverClassName = classNames(className, 'pan-popover')
    const PopoverProps = {
      className: PopoverClassName
    }
    return <AntPopover {...this.props} {...PopoverProps} />
  }
}

Popover.AntPopover = AntPopover
